import React from 'react';
import { Form, Col, Row, Button, Modal } from 'react-bootstrap'
import BootstrapTable from 'react-bootstrap-table-next';
import { Constants } from "../../constants";
import axios, { AxiosRequestConfig } from 'axios';
import SiteMenu from "../menu";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import '../../App.css';
import ReactGA from "react-ga4";

var ReactDOM = require('react-dom');
var TableHeaderColumn = BootstrapTable.TableHeaderColumn;
var arrAcctChangeValue = new Array(16);

function currencyFormat(num) {
    return '$' + num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
}

const acctRecord = {
    CustomerID: '',
    CustomerName: '',
    Address1: '',
    Address2: '',
    Address3: '',
    City: '',
    State: '',
    Zip: '',
    Country: '',
    BillingEmail: '',
    ContactName1: '',
    ContactName2: '',
    Phone1: '',
    Phone2: '',
    Phone3: '',
    user: '',
    userEmail:''
};
class ManageAccounts extends React.Component {



    constructor(props) {
        super(props);

        let userExists = !(props.location.state == null || props.location.state.user == null);

        this.state = {
            user: userExists ? props.location.state.user : {},
            accounts: [],
            loading: false,
            data: [],
            showModal: false,
            showModifyAccountModal: false,
            showAcceptModal: false,
            accountSelected: '',
            accountID: '',
            billingZip: '',
            isEditable: false,
            AcctInput: [],
        };
        this.AcctInput = {
        //    CustomerID: '',
        //    CustomerName:'',
        //    Address1: '',
        //    Address2: '',
        //    Address3: '',
        //    City: '',
        //    State: '',
        //    Zip: '',
        //    Country: '',
        //    BillingEmail: '',
        //    ContactName1: '',
        //    ContactName2: '',
        //    Phone1: '',
        //    Phone2: '',
        //    Phone3: '',
        };
        this.AcctChangeValue = {};

        this.handleTableChange = this.handleTableChange.bind(this);
        this.confirmModal = React.createRef();
        this.ModifyAccountModal = React.createRef();
        this.handleClose = this.handleClose.bind(this);
        this.handleFormChange = this.handleFormChange.bind(this);
        this.handleAccountSubmit = this.handleAccountSubmit.bind(this);
        this.getAccounts = this.getAccounts.bind(this);
        this.InitAcctInput = this.InitAcctInput.bind(this);
        this.ModifyAccount = this.ModifyAccount.bind(this);
    }
    InitAcctInput() {
        this.AcctInput['txtCustomerID'] = this.state.accounts[0].colValue;
        this.AcctInput['txtCustomerName'] = this.state.accounts[1].colValue;
        this.AcctInput['txtAddress1'] = this.state.accounts[2].colValue;
        this.AcctInput['txtAddress2'] = this.state.accounts[3].colValue;
        this.AcctInput['txtAddress3'] = this.state.accounts[4].colValue;
        this.AcctInput['txtCity']             = this.state.accounts[5].colValue;
        this.AcctInput['txtState']            = this.state.accounts[6].colValue;
        this.AcctInput['txtZip']              = this.state.accounts[7].colValue;
        this.AcctInput['txtCountry']          = this.state.accounts[8].colValue;
        this.AcctInput['txtBillingEmail']   = this.state.accounts[9].colValue;
        this.AcctInput['txtContactName1']   = this.state.accounts[10].colValue;
        this.AcctInput['txtContactName2'] = ''; //this.state.accounts[11].colValue;
        this.AcctInput['txtPhone1']           = this.state.accounts[12].colValue.substring(0,10);
        this.AcctInput['txtPhone2']           = '';
        this.AcctInput['txtPhone3']           = this.state.accounts[14].colValue;
        this.AcctInput['txtNotes']           = '';

    } 

    getAccounts(acctID) {
        axios.get(`${Constants.apiURL}/api/Identity/GetAccountsSingle`, {
            params: {
                username: this.state.user.username,
                accountID: acctID //this.state.accountSelected
            }
        }).then(response => {
            if (response.data) {
                this.setState(() => ({
                    accounts: response.data
                }));
                this.InitAcctInput();
                if (acctID != '') {
                    this.setState(() => ({
                        showModifyAccountModal: true
                    }));
                }
            }
        }).catch((response) => {
            // ? Show to user that request is failed
            this.setState({ errors: [response] })
            this.setState({ loading: false });
            console.log('request failed', response)
        });
    }

    ModifyAccount() {
        axios.post(`${Constants.apiURL}/api/Identity/ModifyAccount`, {
            params: {
                acctRecord: acctRecord
                
            }
        }).then(response => {
            if (response.data) {
                
            }
        }).catch((response) => {
            // ? Show to user that request is failed
            this.setState({ errors: [response] })
            this.setState({ loading: false });
            console.log('Modify failed', response)
        });
    }

    componentDidMount() {
        this.handleTableChange();
        this.getAccounts(this.state.accountSelected);
    }

    componentDidUpdate(event) {
        console.log(event);
        if (event.history.location.state && event.location.state.typeofrequest != event.history.location.state.typeofrequest) {
            let input = this.state.input;
            input.typeOfRequest = event.history.location.state.typeofrequest;
            this.setState({ input: input });
        }
    }
    handleAccUpdateChange(event) {
        //let  AcctChangeValue[event.target.name] = event.target.value;
        //this.AcctChangeValue[event.target.name] = v;
        //arrAcctChangeValue[0] = v;
        //this.AcctChangeValue[event.target.name] = v;
    }

    handleFormChange(event) {
        let input = this.state;
        input[event.target.name] = event.target.value;
        this.setState({
            input
        });
    }

    handleTableChange = () => {

        this.setState({
            loading: true
        },
            function () {

                axios.get(`${Constants.apiURL}/api/Identity/GetAccountsM`, {
                    params: {
                        username: this.state.user.username
                    }
                }).then(response => {
                    if (response.data) {

                        this.setState(() => ({
                            data: response.data,
                            loading: false
                        }));
                    }
                }).catch((response) => {
                    // ? Show to user that request is failed
                    this.setState({ errors: [response] })
                    this.setState({ loading: false });
                    console.log('request failed', response)
                });
            });
    }

    handleClose(event) {
        console.log(event);
        if (event && event.target.name == "confirm") {
            axios.post(`${Constants.apiURL}/api/Identity/RemoveAccount`, null, {
                params: {
                    user: this.state.user.username,
                    accountID: this.state.accountSelected
                }
            }).then(response => {
                this.setState({ showModal: false });
                this.handleTableChange();
                if (response.data) {
                    alert(response.data);
                }
                else {
                    alert("Failed to remove account");
                }
            }).catch((response) => {
                // ? Show to user that request is failed
                this.setState({ errors: [response] })
                this.setState({ loading: false });
                console.log('request failed', response)
            });
        }
        else if (event && event.target.name == "Update") {
            // Populate changed values
            acctRecord.CustomerID = (document.getElementById('txtCustomerID').value == '' ? this.AcctInput['txtCustomerID'] : document.getElementById('txtCustomerID').value             +  '  [ Changed ] '   );
            acctRecord.CustomerName = (document.getElementById('txtCustomerName').value == '' ? this.AcctInput['txtCustomerName']   : document.getElementById('txtCustomerName').value   +  '  [ Changed ] '   );
            acctRecord.Address1 = (document.getElementById('txtAddress1').value == '' ? this.AcctInput['txtAddress1']               : document.getElementById('txtAddress1').value       +  '  [ Changed ] '   );
            acctRecord.Address2 = (document.getElementById('txtAddress2').value == '' ? this.AcctInput['txtAddress2']               : document.getElementById('txtAddress2').value       +  '  [ Changed ] '   );
            //acctRecord.Address3 = (document.getElementById('txtAddress3').value == '' ? this.AcctInput['txtAddress3']               : document.getElementById('txtAddress3').value       +  '  [ Changed ] '   );
            acctRecord.City = (document.getElementById('txtCity').value == '' ? this.AcctInput['txtCity']                           : document.getElementById('txtCity').value           +  '  [ Changed ] '   );
            acctRecord.State = (document.getElementById('txtState').value == '' ? this.AcctInput['txtState']                        : document.getElementById('txtState').value          +  '  [ Changed ] '   );
            acctRecord.Zip = (document.getElementById('txtZip').value == '' ? this.AcctInput['txtZip']                              : document.getElementById('txtZip').value            +  '  [ Changed ] '   );
            //acctRecord.Country = (document.getElementById('txtCountry').value == '' ? this.AcctInput['txtCountry']                  : document.getElementById('txtCountry').value        +  '  [ Changed ] '   );
            acctRecord.BillingEmail = (document.getElementById('txtBillingEmail').value == '' ? this.AcctInput['txtBillingEmail']   : document.getElementById('txtBillingEmail').value   +  '  [ Changed ] '   );
            acctRecord.ContactName1 = (document.getElementById('txtContactName1').value == '' ? this.AcctInput['txtContactName1']   : document.getElementById('txtContactName1').value   +  '  [ Changed ] '   );
            acctRecord.ContactName2 = (document.getElementById('txtContactName2').value == '' ? this.AcctInput['txtContactName2']   : document.getElementById('txtContactName2').value   +  '  [ Changed ] '   );
            acctRecord.Phone1 = (document.getElementById('txtPhone1').value == '' ? this.AcctInput['txtPhone1']                     : document.getElementById('txtPhone1').value         +  '  [ Changed ] '   );
            acctRecord.Phone2 = (document.getElementById('txtPhone2').value == '' ? this.AcctInput['txtPhone2']                     : document.getElementById('txtPhone2').value         +  '  [ Changed ] '   );
            //acctRecord.Phone3 = (document.getElementById('txtPhone3').value == '' ? this.AcctInput['txtPhone3']                     : document.getElementById('txtPhone3').value + '  [ Changed ] ');
            acctRecord.Notes  = (document.getElementById('txtNotes').value == '' ? this.AcctInput['txtNotes']                       : document.getElementById('txtNotes').value );
            acctRecord.user = this.state.user.username;
            acctRecord.userEmail = this.state.user.email;

            // Get Account change info
            let info = (document.getElementById('txtCustomerID').value      == '' ? '' : '\nCustomerID: '   + document.getElementById('txtCustomerID').value   )
                     + (document.getElementById('txtCustomerName').value    == '' ? '' : '\nCustomerName: ' + document.getElementById('txtCustomerName').value )
                     + (document.getElementById('txtAddress1').value        == '' ? '' : '\nAddress1: '     + document.getElementById('txtAddress1').value     )
                     + (document.getElementById('txtAddress2').value        == '' ? '' : '\nAddress2: '     + document.getElementById('txtAddress2').value     )
                     //+ (document.getElementById('txtAddress3').value        == '' ? '' : '\nAddress3: '     + document.getElementById('txtAddress3').value     )
                     + (document.getElementById('txtCity').value            == '' ? '' : '\nCity: '         + document.getElementById('txtCity').value         )
                     + (document.getElementById('txtState').value           == '' ? '' : '\nState: '        + document.getElementById('txtState').value        )
                     + (document.getElementById('txtZip').value             == '' ? '' : '\nZip: '          + document.getElementById('txtZip').value          )
                     //+ (document.getElementById('txtCountry').value         == '' ? '' : '\nCountry: '      + document.getElementById('txtCountry').value      )
                     + (document.getElementById('txtBillingEmail').value    == '' ? '' : '\nBillingEmail: ' + document.getElementById('txtBillingEmail').value )
                     + (document.getElementById('txtContactName1').value    == '' ? '' : '\nContactName1: ' + document.getElementById('txtContactName1').value )
                     + (document.getElementById('txtContactName2').value    == '' ? '' : '\nContactName2: ' + document.getElementById('txtContactName2').value )
                     + (document.getElementById('txtPhone1').value          == '' ? '' : '\nPhone1: '       + document.getElementById('txtPhone1').value       )
                     + (document.getElementById('txtPhone2').value          == '' ? '' : '\nPhone2: '       + document.getElementById('txtPhone2').value       )
                     //+ (document.getElementById('txtPhone3').value          == '' ? '' : '\nPhone3: '       + document.getElementById('txtPhone3').value       )
                     + (document.getElementById('txtNotes').value           == '' ? '' : '\nPhone3: '       + document.getElementById('txtNotes').value       )
                ;
            if (info == '')
                alert('No account information changed, update cancelled.');
            else {
                this.ModifyAccount();
                 this.setState(() => ({
                    showAcceptModal: true
                }));
               //let rtnMsg = 'Submission Received!'
                //    +'\nThank you for submitting your request to change your account information.Your submission has been successfully received and is now pending review by our Accounting Department.'
                //    +'\nWhat Happens Next ?'
                //    +'\nReview Process: Our Accounting Department will review your request to ensure accuracy and compliance with our policies.This process typically takes 2 - 3 business days.'
                //    +'\nApproval Notification: Once your request has been reviewed and approved, you will receive an email confirmation with the details of the changes made to your account.'
                //    +'\nNeed Further Assistance ? If you have any questions or need to provide additional information, please do not hesitate to contact us at 240 - 306 - 3000 or info @boland.com  Our support team is here to help!'
                //    + '\nThank You for Your Patience!';
                //alert(rtnMsg);
                //alert('Following account information changed:' + info + '\n\nChanges will be verified by Boland accounting department, and notify you by email. ');
            }


            this.setState({ showModifyAccountModal: false });
        }
        else if (event && event.target.name == "AcceptOK") {
            this.setState({
                showAcceptModal: false
            });

        }
        else {
            this.setState({
                showModal: false,
                showModifyAccountModal: false,
                showAcceptModal: false

            });
        }
    }

    handleAccountSubmit(event) {
        event.preventDefault();
        if (this.state.accountID == '' || this.state.billingZip == '') return;


        if (!String(this.state.billingZip)
            .toLowerCase()
            .match(/^[0-9]{5}(?:-[0-9]{4})?$/
        )) {
            alert('Invalid zip code.');
            return;
        }
        axios.post(`${Constants.apiURL}/api/Identity/AddAccount`, null, {
            params: {
                user: this.state.user.username,
                accountID: this.state.accountID,
                billingZip: this.state.billingZip
            }
        }).then(response => {
            this.handleTableChange();
            if (response.data) {
                ReactGA.event({
                    category: 'Account',
                    action: 'Add Account',
                    label: this.state.accountID
                });
                alert(response.data);
            }
            else {
                alert("Unable to add account. Please confirm your account ID and billing zip.");
            }
        }).catch((response) => {
            // ? Show to user that request is failed
            this.setState({ errors: [response] })
            this.setState({ loading: false });
            console.log('request failed', response)
        });
    }

    render() {
        const { data, accounts, sizePerPage, page, showModal, showModifyAccountModal, showAcceptModal, selectRow, AcctInput } = this.state;
        const twoCols = [
            {
                dataField: 'colName',
                text: 'Name',
                align: 'left',
                headerStyle: (colum, colIndex) => {
                    return { width: '160px', textAlign: 'center', backgroundColor: '#1F419B', color: 'white' };
                },
                style: {
                    verticalAlign: 'middle'
                }
            },
            {
                dataField: 'colValue',
                text: 'Value',
                align: 'left',
                headerStyle: (colum, colIndex) => {
                    return { width: '360px', textAlign: 'center', backgroundColor: '#1F419B', color: 'white' };
                },
                style: {
                    verticalAlign: 'middle'
                }
            },
        //    {
        //        text: 'Change To',
        //        align: 'left',
        //        headerStyle: (colum, colIndex) => {
        //            return { width: '360px', textAlign: 'center', backgroundColor: '#1F419B', color: 'white' };
        //        },
        //        style: {
        //            verticalAlign: 'middle'
        //        }

        //    }
        ];

        const columns = [
            {
                dataField: 'accountID',
                text: 'Account #',
                align: 'center',
                headerStyle: (colum, colIndex) => {
                    return { width: '80px', textAlign: 'center', backgroundColor: '#1F419B', color: 'white' };
                },
                style: {
                    verticalAlign: 'middle'
                }
            },
            {
                dataField: 'accountName',
                text: 'Account Name',
                align: 'center',
                headerStyle: (colum, colIndex) => {
                    return { width: '250px', textAlign: 'center', backgroundColor: '#1F419B', color: 'white' };
                },
                style: {
                    verticalAlign: 'middle'
                }
            },
            {
                dataField: 'billingAddress',
                text: 'Billing Address',
                align: 'center',
                headerStyle: (colum, colIndex) => {
                    return { width: '250px', textAlign: 'center', backgroundColor: '#1F419B', color: 'white' };
                },
                style: {
                    verticalAlign: 'middle'
                }
            },
            {
                dataField: 'role',
                text: 'Access Level',
                align: 'center',
                headerStyle: (colum, colIndex) => {
                    return { width: '100px', textAlign: 'center', backgroundColor: '#1F419B', color: 'white' };
                },
                style: {
                    verticalAlign: 'middle'
                },
                formatter: (cell, row) => {
                    return (
                        <Form.Select disabled value={cell} size="md" name="filterType" style={{ backgroundImage: 'none' }}>
                            <option value="ORD_ACCOUNTADMIN">Account Admin</option>
                            <option value="ORD_FULLACCESS">Standard + Finance</option>
                            <option value="ORD_WORKONLY">Standard User</option>
                        </Form.Select>);
                }
            },
            {
                text: '',
                dataField: 'currentAccountBalance',
                align: 'center',
                headerStyle: (colum, colIndex) => {
                    return { width: '60px', textAlign: 'center', backgroundColor: '#1F419B', color: 'white' };
                },
                formatter: (cell, row, props) => {
                    return <Button style={{ backgroundColor: '#1F419B', width:'100px' }} onClick={(event) => {
                        this.setState({ accountSelected: row.accountID, showModal: true });
                    }}>Remove</Button>
                },
                style: {
                    verticalAlign: 'middle'
                }
            },
            {
                text: '',
                dataField: 'currentAccountBalance',
                align: 'center',
                headerStyle: (colum, colIndex) => {
                    return { width: '60px', textAlign: 'center', backgroundColor: '#1F419B', color: 'white' };
                },
                formatter: (cell, row, props) => {
                    return <Button style={{ backgroundColor: '#1F419B', width: '100px' }} onClick={(event) => {
                        this.getAccounts(row.accountID);
                        this.setState({ accountSelected: row.accountID });
                    }}>Update</Button>
                },
                style: {
                    verticalAlign: 'middle',
                }
            }
        ];
        return (
            <div>
                <SiteMenu user={this.state.user} currentPage='manageAccounts' />
                <Form.Label className="form-header" style={{ padding: '10px 20px 0px 15px' }}>Manage accounts</Form.Label>
                <Form.Label style={{ fontSize: '15px', paddingTop: '0px', paddingLeft:'15px', fontStyle: 'italic' }}><strong>Don't know your Boland account information?</strong> These numbers may be found on Boland invoices. Please contact your company's billing department or your Boland account executive if you cannot locate account information.</Form.Label>
                <Modal ref={this.confirmModal} show={showModal} onHide={this.handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>Confirm</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>Confirm removal of account from your user profile.</Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" name="cancel" onClick={this.handleClose}>
                            Cancel
                        </Button>
                        <Button variant="primary" name="confirm" onClick={this.handleClose}>
                            Confirm
                        </Button>
                    </Modal.Footer>
                </Modal>
                {/*Message Box for accepting Account changes*/}
                <Modal ref={this.ReturnMessageModal} show={showAcceptModal} onHide={this.handleClose} dialogClassName="modalCustomWidth" >
                    <Modal.Header closeButton>
                        <Modal.Title>Account Information Change</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                       <h5>Submission Received!</h5>

                        <p>Thank you for submitting your request to change your account information. Your submission has been successfully received and is now pending review by our Accounting Department.</p>

                        <h5>What Happens Next?</h5>
                            
                        <p><b>Review Process:</b> Our Accounting Department will review your request to ensure accuracy and compliance with our policies. This process typically takes 2-3 business days. </p>
                        <p><b>Approval Notification: </b>Once your request has been reviewed and approved, you will receive an email confirmation with the details of the changes made to your account.</p>
                        <p><b>Need Further Assistance? </b>If you have any questions or need to provide additional information, please do not hesitate to contact us at 240-306-3000 or info@boland.com  Our support team is here to help!</p>

                        <h5>Thank You for Your Patience! </h5>

                        <p>We appreciate your patience during this review process. Ensuring the security and accuracy of your account information is our top priority.</p>

                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" name="AcceptOK" onClick={this.handleClose}>OK</Button>
                    </Modal.Footer>
                </Modal>

                <Modal ref={this.ModifyAccountModal} show={showModifyAccountModal} onHide={this.handleClose}  size='lg'>
                    <Modal.Header closeButton>
                        <Modal.Title>Update Account Information</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                    <Form className="mobile-justify-left"   as={Row} controlId="ChangeForm" style={{ padding: '10px 10px 0px 10px', justifyContent: 'left' }}>
                        <Form.Label className="mobile-text-align-l mobile-p-l-10" style={{ alignSelf: 'center', textAlign: 'left', padding: 20, fontWeight: 'bold' }} column md={12}>Enter Account Information you want to change (leave intact if not)</Form.Label>
                        <Form.Group as={Row} className="mb-12">
                            <Form.Label className="mobile-text-align-l mobile-p-l-10" style={{ alignSelf: 'center', textAlign: 'right', padding: 10 }} column md={3}>Customer ID</Form.Label>
                            <Col md={9}>
                                <Form.Control type="input" placeholder={this.AcctInput['txtCustomerID']} id="txtCustomerID"  name="txtCustomerID" readOnly={true} style={{ minWidth: "200px" }} />
                            </Col>
                            <Form.Label className="mobile-text-align-l mobile-p-l-10" style={{ alignSelf: 'center', textAlign: 'right', padding: 10 }}  column md={3}>Customer Name</Form.Label>
                            <Col md={9}>
                                <Form.Control type="input" placeholder={this.AcctInput['txtCustomerName']} id="txtCustomerName" name="txtCustomerName" readOnly={true} style={{ minWidth: "200px" }} />
                            </Col>
                            <Form.Label className="mobile-text-align-l mobile-p-l-10" style={{ alignSelf: 'center', textAlign: 'right', padding: 10 }} column md={3}>Billing (Street / PO Box)</Form.Label>
                            <Col md={9}>
                                <Form.Control type="input" placeholder={this.AcctInput['txtAddress1']} id="txtAddress1" name="txtAddress1" style={{ minWidth: "200px" }} />
                            </Col>
                            <Form.Label className="mobile-text-align-l mobile-p-l-10" style={{ alignSelf: 'center', textAlign: 'right', padding: 10 }} column md={3}>Billing Address Ln.2</Form.Label>
                            <Col md={9}>
                                <Form.Control type="input" placeholder={this.AcctInput['txtAddress2']} id="txtAddress2" name="txtAddress2" style={{ minWidth: "200px" }} />
                            </Col>
                            {/*<Form.Label className="mobile-text-align-l mobile-p-l-10" style={{ alignSelf: 'center', textAlign: 'right', padding: 10 }} column md={3}>Customer Address 3</Form.Label>*/}
                            {/*<Col md={9}>*/}
                            {/*    <Form.Control type="input" placeholder={this.AcctInput['txtAddress3']} id="txtAddress3" name="txtAddress3" style={{ minWidth: "200px" }} />*/}
                            {/*</Col>*/}
                            <Form.Label className="mobile-text-align-l mobile-p-l-10" style={{ alignSelf: 'center', textAlign: 'right', padding: 10 }} column md={3}>Billing City</Form.Label>
                            <Col md={9}>
                                <Form.Control type="input" placeholder={this.AcctInput['txtCity']} id="txtCity" name="txtCity" style={{ minWidth: "200px" }} />
                            </Col>
                           <Form.Label className="mobile-text-align-l mobile-p-l-10" style={{ alignSelf: 'center', textAlign: 'right', padding: 10 }} column md={3}>Billing State</Form.Label>
                            <Col md={9}>
                                <Form.Control type="input" placeholder={this.AcctInput['txtState']} id="txtState" name="txtState" style={{ minWidth: "200px" }} />
                            </Col>
                            <Form.Label className="mobile-text-align-l mobile-p-l-10" style={{ alignSelf: 'center', textAlign: 'right', padding: 10 }} column md={3}>Billing Zip</Form.Label>
                            <Col md={9}>
                                <Form.Control type="input" placeholder={this.AcctInput['txtZip']} id="txtZip" name="txtZip" style={{ minWidth: "200px" }} />
                            </Col>
                            {/*<Form.Label className="mobile-text-align-l mobile-p-l-10" style={{ alignSelf: 'center', textAlign: 'right', padding: 10 }} column md={3}>Customer Country</Form.Label>*/}
                            {/*<Col md={9}>*/}
                            {/*    <Form.Control type="input" placeholder={this.AcctInput['txtCountry']} id="txtCountry" name="txtCountry" style={{ minWidth: "200px" }} />*/}
                            {/*</Col>*/}
                            <Form.Label className="mobile-text-align-l mobile-p-l-10" style={{ alignSelf: 'center', textAlign: 'right', padding: 10 }} column md={3}>E-Billing Email</Form.Label>
                            <Col md={9}>
                                <Form.Control type="input" placeholder={this.AcctInput['txtBillingEmail']} id="txtBillingEmail" name="txtBillingEmail" style={{ minWidth: "200px" }} />
                            </Col>
                            <Form.Label className="mobile-text-align-l mobile-p-l-10" style={{ alignSelf: 'center', textAlign: 'right', padding: 10 }} column md={3}>A/P Contact Name</Form.Label>
                            <Col md={9}>
                                <Form.Control type="input" placeholder={this.AcctInput['txtContactName1']} id="txtContactName1" name="txtContactName1" style={{ minWidth: "200px" }} />
                            </Col>
                            <Form.Label className="mobile-text-align-l mobile-p-l-10" style={{ alignSelf: 'center', textAlign: 'right', padding: 10 }} column md={3}>A/P Contact Email</Form.Label>
                            <Col md={9}>
                                <Form.Control type="input" placeholder={this.AcctInput['txtContactName2']} id="txtContactName2" name="txtContactName2" style={{ minWidth: "200px" }} />
                            </Col>
                            <Form.Label className="mobile-text-align-l mobile-p-l-10" style={{ alignSelf: 'center', textAlign: 'right', padding: 10 }} column md={3}>A/P Contact Phone</Form.Label>
                            <Col md={9}>
                                <Form.Control type="input" placeholder={this.AcctInput['txtPhone1']} id="txtPhone1" name="txtPhone1" style={{ minWidth: "200px" }} />
                            </Col>
                           <Form.Label className="mobile-text-align-l mobile-p-l-10" style={{ alignSelf: 'center', textAlign: 'right', padding: 10 }} column md={3}>Update Requested By</Form.Label>
                            <Col md={9}>
                                <Form.Control type="input" placeholder={this.AcctInput['txtPhone2']} id="txtPhone2" name="txtPhone2" style={{ minWidth: "200px" }} />
                            </Col>
                            {/*<Form.Label className="mobile-text-align-l mobile-p-l-10" style={{ alignSelf: 'center', textAlign: 'right', padding: 10 }} column md={3}>Phone 3</Form.Label>*/}
                            {/*<Col md={9}>*/}
                            {/*    <Form.Control type="input" placeholder={this.AcctInput['txtPhone3']} id="txtPhone3" name="txtPhone3" style={{ minWidth: "200px" }} />*/}
                            {/*</Col>*/}
                            <Form.Label className="mobile-text-align-l mobile-p-l-10" style={{ alignSelf: 'Top', textAlign: 'right', padding: 10 }} column md={3}>Notes</Form.Label>
                            <Col md={9}>
                                <Form.Control as="textarea" rows={5} placeholder="Notes to Boland" id="txtNotes" name="txtNotes" style={{ minWidth: '200px', minHeight: '120px', verticalAlign:'Top' }} />
                            </Col>
                       </Form.Group>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" name="cancel" onClick={this.handleClose}>
                            Cancel
                        </Button>
                        <Button variant="primary" name="Update" onClick={this.handleClose}>
                            Update
                        </Button>
                    </Modal.Footer>
                </Modal>

                <BootstrapTable
                    bootstrap4
                    keyField="Id"
                    wrapperClasses="table-responsive manage-accounts-table"
                    data={data}
                    columns={columns}
                    onTableChange={this.handleTableChange}
                    noDataIndication={() => <Form.Label>No accounts found.</Form.Label>}
                    hover
                    striped
                />

                <Form className="mobile-justify-left" onSubmit={this.handleAccountSubmit} as={Row} controlId="searchForm" style={{ padding: '10px 10px 0px 10px', justifyContent: 'right' }}>
                    <Col width="100%"/>
                    <Col md={3}>
                        <Form.Group as={Row} className="mb-3">
                            <Form.Label className="mobile-text-align-l mobile-p-l-10" style={{ alignSelf: 'center', textAlign: 'right', padding: 0, fontWeight:'bold' }} column md={4}>Add new account</Form.Label>
                            <Col md={8}>
                                <Form.Control type="input" onChange={this.handleFormChange} placeholder="Enter account ID" name="accountID" style={{ minWidth: "200px" }} />
                            </Col>
                        </Form.Group>
                    </Col>
                    <Col md={2}>
                        <Form.Control type="input" onChange={this.handleFormChange} placeholder="Enter account billing zip" name="billingZip" style={{ minWidth: "200px" }} />
                    </Col>
                    <Col className="mobile-m-t-10 mobile-m-l-10" md="auto" sm="auto" xs="auto" style={{ paddingLeft: 0 }}>
                        <Button style={{ backgroundColor: '#1F419B' }} type="submit" onClick={this.handleAccountSubmit} >
                            Submit
                        </Button>
                    </Col>
                </Form>
            </div>
        );
    }
}
export default ManageAccounts;